import { Button } from "primereact/button";
import { deleteReferenceDatum } from "../../../../api-requests/reference-data";
import TrashIcon from "../../../../components/icons/TrashIcon";
import { appLog } from "../../../../context";
import { useRefreshReferencesNReferenceData } from "../../../../store/store-hooks";
import { syncOpenModalDialog } from "../../../shared/global-tools/dialog-system";
import { showToast } from "../../../shared/global-tools/toast-system";
import makeConfirmDialog from "../ConfirmDialog/ConfirmDialog";

export default function DeleteAction({
  referenceDatumId,
  referenceId,
}: { referenceDatumId: number; referenceId: number }) {
  const refresh = useRefreshReferencesNReferenceData(referenceId);

  const handleReferenceDatumDeletion = async () => {
    try {
      await deleteReferenceDatum({
        referenceId,
        datumId: referenceDatumId,
      });
      showToast("Donnée supprimée", { severity: "success" });
      refresh();
    } catch (error) {
      appLog.error(error);
      showToast("Echec suppression donnée", { severity: "error", sticky: true });
    }
  };

  return (
    <Button
      className="IconOnlyBtn"
      icon={<TrashIcon />}
      severity="danger"
      rounded
      text
      onClick={() =>
        syncOpenModalDialog(makeConfirmDialog, {
          onConfirm: handleReferenceDatumDeletion,
          warningMessage: "Voulez-vous supprimer cette donnée?",
        })
      }
    />
  );
}
